import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

type DotProps = {
  color: string;
} & BoxProps;

export const Dot: FC<DotProps> = (props) => {
  const { color, sx } = props;

  return (
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: color,
        ...sx
      }}
    />
  );
};
